import {
  Directive,
  effect,
  ElementRef,
  input,
  Renderer2,
  untracked,
  inject,
} from '@angular/core';
import { AssetImage } from '../enums/asset-image';
import { AssetImagesProviderService } from '../providers/asset-images-provider.service';

@Directive({
  selector: '[appBackgroundImage]',
  standalone: true,
})
export class BackgroundImageDirective {
  private readonly provider = inject(AssetImagesProviderService);
  private readonly renderer = inject(Renderer2);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  public readonly image = input.required<AssetImage>();

  public constructor() {
    effect(() => untracked(() => this.configureBackgroundImageUrl()));
  }

  private configureBackgroundImageUrl(): void {
    this.renderer.setStyle(
      this.elementRef.nativeElement,
      'background-image',
      `url('${this.provider.url(this.image())}')`,
    );
  }
}
